export const SMS_OPT_IN_TOAST_ID = 'sms-opt-in'
export const COMMISSIONS_TOAST_ID = 'commissionsOptOut'

/** Toast ids for a single add-to-cart result, one at a time (see `useUniqueToast`). */
export const ADD_TO_CART_TOAST_ID_PREFIX = 'addtocart-'

/**
 * The success half of that group, nested so the prefix above still matches every add-to-cart toast.
 *
 * Opening the cart clears these and only these: the cart shows what a success announced, while the
 * failure and removed toasts are `persist: true` and carry warnings the cart does not repeat.
 */
export const ADD_TO_CART_SUCCESS_TOAST_ID_PREFIX = `${ADD_TO_CART_TOAST_ID_PREFIX}success-`
